/**
 * 宝箱（ゴール）
 *
 * 純粋なロジック層: 位置管理と到達判定のみ。
 * 描画は TreasureRenderer が担当。
 */
export class Treasure {
  private _gridX: number;
  private _gridY: number;

  constructor(gridX: number, gridY: number) {
    this._gridX = gridX;
    this._gridY = gridY;
  }

  get gridX(): number {
    return this._gridX;
  }

  get gridY(): number {
    return this._gridY;
  }

  /**
   * 指定座標が宝の位置かどうか
   */
  isAt(gridX: number, gridY: number): boolean {
    return this._gridX === gridX && this._gridY === gridY;
  }
}
